<public-account-shell [heading]="'account.resetPassword.title' | transloco">
  @switch (state()) {
    @case ('form') {
      <form class="reset__form" (ngSubmit)="onSubmit()">
        <div class="reset__field">
          <label class="reset__label" for="password">{{ 'account.resetPassword.password' | transloco }}</label>
          <input
            id="password"
            name="password"
            type="password"
            class="reset__input"
            [ngModel]="password()"
            (ngModelChange)="password.set($event)"
            autocomplete="new-password"
            [attr.aria-describedby]="'password-requirements'"
            required
          />
          <password-strength-meter [password]="password()" />
          <span id="password-requirements" class="reset__hint">
            {{ 'account.resetPassword.passwordRequirements' | transloco: { minLength: minimumPasswordLength } }}
          </span>
        </div>

        <div class="reset__field">
          <label class="reset__label" for="confirmPassword">
            {{ 'account.resetPassword.confirmPassword' | transloco }}
          </label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            class="reset__input"
            [class.reset__input--invalid]="!passwordsMatch()"
            [ngModel]="confirmPassword()"
            (ngModelChange)="confirmPassword.set($event)"
            autocomplete="new-password"
            required
          />
          @if (!passwordsMatch()) {
            <span class="reset__error">{{ 'account.resetPassword.errors.passwordsDoNotMatch' | transloco }}</span>
          }
        </div>

        <button eBtn block color="primary" type="submit" [disabled]="!canSubmit()" [loading]="isSubmitting()">
          {{ 'account.resetPassword.submit' | transloco }}
        </button>
      </form>
    }
    @case ('success') {
      <div class="reset__result" role="status">
        <i class="fa-solid fa-circle-check reset__icon reset__icon--success" aria-hidden="true"></i>
        <p class="reset__text">{{ 'account.resetPassword.success' | transloco }}</p>
        <button eBtn block color="primary" type="button" routerLink="/login">
          {{ 'account.resetPassword.toLogin' | transloco }}
        </button>
      </div>
    }
    @default {
      <div class="reset__result" role="alert">
        <i class="fa-solid fa-circle-exclamation reset__icon reset__icon--error" aria-hidden="true"></i>
        <p class="reset__text">
          {{ (state() === 'missingToken' ? 'account.resetPassword.missingToken' : 'account.resetPassword.failed') | transloco }}
        </p>
        <a routerLink="/forgot-password" class="reset__link">
          {{ 'account.resetPassword.requestNew' | transloco }}
        </a>
      </div>
    }
  }
</public-account-shell>
